<div class="grid">
	<div class="col-12">
		<p-table
			#tableTecnichiansList
			dataKey="i"
			[value]="technicians"
			[paginator]="true"
			[loading]="techniciansLoading"
			[rows]="pageSize"
			[showCurrentPageReport]="true"
			currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}"
			[autoLayout]="true"
			responsiveLayout="stack">

			<ng-template pTemplate="caption">
				<div class="grid">
					<div class="col-12" [class]="underTablet() ? 'flex justify-content-center' : 'flex justify-content-start'">
						<p-button label="{{ 'ADD_TECHNICIAN' | translate }}" (onClick)="addTechnician();" icon="pi cm-plus"
							[rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary">
						</p-button>
					</div>
				</div>
			</ng-template>
			<ng-template pTemplate="header">
				<tr>
					<th>
						<div class="flex align-items-center justify-content-center">
							{{ 'TECHNICIAN' | translate }}
						</div>
					</th>
					<th>
						<div class="flex align-items-center justify-content-center">
							{{ 'EMAIL' | translate }}
						</div>
					</th>
					<th>
						<div class="flex align-items-center justify-content-center">
							{{ 'ASSOCIATED_SITES' | translate }}
						</div>
					</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-user>
				<tr>
						<td>
								<span class="p-column-title font-semibold">{{ 'TECHNICIAN' | translate }}</span>{{ user.FirstName + ' ' + user.LastName}}
						</td>
						<td>
								<span class="p-column-title font-semibold">{{ 'EMAIL' | translate }}</span>{{ user.Email }}
						</td>
						<td>
								<span class="p-column-title font-semibold">{{ 'ASSOCIATED_SITES' | translate }}</span>
								<div class="flex flex-column">
									<div *ngFor="let site of getTechSites(user.Id)" class="pb-2">
										{{ site | truncate:[50] }}
									</div>
								</div>
						</td>
						<td>
								<span class="p-column-title"></span>
								<div class="flex flex-row justify-content-center align-items-center">
								<p-button pTooltip="{{ 'ASSOCIATED_SITES' | translate }}" tooltipPosition="bottom" icon="pi cm-pencil" (click)="editTechnician(user)" [rounded]="false" [text]="true" severity="primary" size="large"></p-button>
								<p-button pTooltip="{{ 'UNASSIGN_TECHNICIAN' | translate }}" tooltipPosition="bottom" icon="pi cm-trash" (click)="unAssignTechnician($event, user)" 
									[disabled]="canDeleteSite(user.Id)"
									[rounded]="false" [text]="true" severity="danger" size="large">
								</p-button>
								</div>
						</td>
				</tr>
			</ng-template>
			<ng-template pTemplate="emptymessage">
				<tr>
					<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton
					[label]="confDialog.acceptButtonLabel"
					[ngClass]="acceptButtonStyle"
					(click)="confDialog.accept()">
			</button>
			<button type="button" pButton
					[label]="confDialog.rejectButtonLabel"
					[ngClass]="rejectButtonStyle"
					(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>